import React, { useEffect, useState, useLayoutEffect } from "react";
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import { ShowToast } from "../../../common/Toastr";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../../common/Loader";
import fetchAPI from "../../../common/fetchAPI";
import Select, { StylesConfig } from 'react-select';
import { ShowSwalWithConfirmation } from "../../../common/SweetAlert";
import { getValueFromResource } from "../../../common/timeLiveFunction";
import { getPagePermissionsAsync } from "../../../common/GlobalSlice";

const objErrorValues = {
  isError: false,
  errorMessage: []
}

const TimesheetTemplate = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  // const { accountEmployeeId } = location.state || {};
  // const { sessionAccountId, sessionAccountEmployeeId, showClientInTimesheet } = useAppSelector((state) => state.globalState);
  const { menuList } = useAppSelector((state) => state.globalState);
  let sessionAccountId = localStorage.getItem("accountId");
  let accountEmployeeId = localStorage.getItem("accountEmployeeId");
  let showClientInTimesheet = JSON.parse(localStorage.getItem("showClientInTimesheet") || 'false');

  const [timesheetTemplateResponse, setTimesheetTemplateResponse] = useState<any>([]);
  const [clientResponse, setClientResponse] = useState([]);
  const [projectResponse, setProjectResponse] = useState([]);
  const [setError, setErrorValues] = useState<any | ''>(objErrorValues);
  const [isLoading, setIsLoading] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);
  const dispatch = useAppDispatch();
  const pageId: string = '18';

  useLayoutEffect(() => {
    const fetchPagePermissions = async () => {
      if (pageId && pageId !== '') {
        const res = await dispatch(getPagePermissionsAsync(pageId));
        if (!res.payload.IsList) {
          navigate('../error/403');
        }
      }
    }
    fetchPagePermissions();
  }, [dispatch, location.pathname, menuList, navigate, pageId]);

  useEffect(() => {
    getAccountClients().then((response) => {
      getTimesheetTemplateAsync();
    });
  }, []);

  const getTimesheetTemplateAsync = async () => {
    const response = await fetchAPI(`api/v2/TimesheetTemplate/GetTimesheetTemplateList/${sessionAccountId}/${accountEmployeeId}`, 'Get', '', true);
    const json = await response.json();
    let tempTimesheetTemplate: any[] = [];
    if (json.length > 0) {
      json.map((item: any) => {
        if (item.AccountId != null) {
          item.ProjectTaskArray = [{ "value": item.AccountProjectTaskId, "label": item.TaskName }];
          if (showClientInTimesheet) {
            item.ProjectArray = [{ "value": item.AccountProjectId, "label": item.ProjectName }];
          }
          tempTimesheetTemplate.push(item);
        }
      });
    }
    // for (let i = 0; i < 5; i++) {
    //   tempTimesheetTemplate.push({
    //     "AccountClientId": 0,
    //     "AccountProjectId": 0,
    //     "AccountProjectTaskId": 0,
    //     "AccountEmployeeId": accountEmployeeId,
    //     "AccountEmployeeTimeEntryTemplateId": "",
    //     "AccountId": sessionAccountId,
    //     "ProjectTaskArray": [{ "value": 0, "label": "None" }],
    //     "IsTaskDisabled": true,
    //     "ProjectArray": [{ "value": 0, "label": "None" }],
    //     "IsProjectDisabled": true,
    //     "IsProjectTaskRender": false
    //   })
    // }
    setTimesheetTemplateResponse(tempTimesheetTemplate);
    setIsLoading(false);
    setIsDisabled(false);
  }

  const getAccountClients = async () => {
    const response = await fetchAPI(`api/Timesheets/GetAccountClientForTimesheet/${accountEmployeeId}/0`, 'Get', '', true);
    const json = await response.json();
    json.length > 0 && json.map((item: any, index: any) => {
      item.value = item.AccountClientId;
      item.label = item.ClientName;
      delete item.AccountClientId;
      delete item.ClientName;
    });
    json.unshift({ "value": 0, "label": "None" });
    setClientResponse(json);
    showClientInTimesheet === false && getAccountProjectsByAccountClientId();
  }

  const getAccountProjectsByAccountClientId = async (accountClientId: number = 0, accountEmployeeTimeEntryTemplateId: string = '', index: number = 0) => {
    const response = await fetchAPI(`api/Projects/GetAccountProjectsForTimesheet/${accountClientId}/${accountEmployeeId}`, 'Get', '', true);
    const json = await response.json();
    json.length > 0 && json.map((item: any, index: any) => {
      item.value = item.AccountProjectId;
      item.label = item.ProjectName;
      delete item.AccountProjectId;
      delete item.ProjectName;
      delete item.AccountClientId;
      delete item.ProjectCode;
    });
    json.unshift({ "value": 0, "label": "None" });
    showClientInTimesheet ? updateProjectArray(accountEmployeeTimeEntryTemplateId, accountClientId, json, index) : setProjectResponse(json);
  }

  const getAccountProjectTaskByAccountProjectId = async (accountProjectId: number = 0, accountEmployeeTimeEntryTemplateId: string = '', index: number = 0) => {
    const response = await fetchAPI(`api/Timesheets/GetAccountProjectTasksForTimesheet/${accountProjectId}/${accountEmployeeId}`, 'Get', '', true);
    const json = await response.json();
    json.length > 0 && json.map((item: any, index: any) => {
      item.value = item.AccountProjectTaskId;
      item.label = item.TaskName;
      delete item.AccountProjectTaskId;
      delete item.TaskName;
      delete item.IsBillable;
      delete item.TaskCode;
    });
    json.unshift({ "value": 0, "label": "None" });
    updateProjectTaskArray(accountEmployeeTimeEntryTemplateId, accountProjectId, json, index);
  }

  const updateProjectTaskArray = (id: string, accountProjectId: number, newProjectTaskArray: any, index: number) => {
    id != "" ? setTimesheetTemplateResponse((prevState: any) =>
      prevState.map((item: any) =>
        item.AccountEmployeeTimeEntryTemplateId === id
          ? {
            ...item,
            ProjectTaskArray: newProjectTaskArray,
            AccountProjectId: accountProjectId,
            IsTaskDisabled: newProjectTaskArray.length > 1 ? false : true,
            AccountProjectTaskId: 0
          }
          : item
      )
    ) : setTimesheetTemplateResponse((prevState: any) => {
      const updatedState = [...prevState];
      if (index >= 0 && index < updatedState.length) {
        updatedState[index] = {
          ...updatedState[index],
          ProjectTaskArray: newProjectTaskArray,
          AccountProjectId: accountProjectId,
          IsTaskDisabled: newProjectTaskArray.length > 1 ? false : true,
          AccountProjectTaskId: 0
        };
      }
      return updatedState;
    });
  }

  const updateProjectArray = (id: string, accountClientId: number, newProjectArray: any, index: number) => {
    id != "" ? setTimesheetTemplateResponse((prevState: any) =>
      prevState.map((item: any) =>
        item.AccountEmployeeTimeEntryTemplateId === id
          ? {
            ...item,
            ProjectArray: newProjectArray,
            AccountClientId: accountClientId,
            IsProjectDisabled: newProjectArray.length > 1 ? false : true
          }
          : item
      )
    ) : setTimesheetTemplateResponse((prevState: any) => {
      const updatedState = [...prevState];
      if (index >= 0 && index < updatedState.length) {
        updatedState[index] = {
          ...updatedState[index],
          ProjectArray: newProjectArray,
          AccountClientId: accountClientId,
          IsProjectDisabled: newProjectArray.length > 1 ? false : true,
        };
      }
      return updatedState;
    });
  }

  const onHandleProjectChange = (selected: any, accountEmployeeTimeEntryTemplateId: string, index: number) => {
    getAccountProjectTaskByAccountProjectId(selected.value, accountEmployeeTimeEntryTemplateId, index);
  }

  const onHandleClientChange = (selected: any, accountEmployeeTimeEntryTemplateId: string, index: number) => {
    getAccountProjectsByAccountClientId(selected.value, accountEmployeeTimeEntryTemplateId, index);
  }

  const onHandleProjectTaskChange = (selected: any, accountEmployeeTimeEntryTemplateId: string, index: number) => {
    accountEmployeeTimeEntryTemplateId != "" ? setTimesheetTemplateResponse((prevState: any) =>
      prevState.map((item: any) =>
        item.AccountEmployeeTimeEntryTemplateId === accountEmployeeTimeEntryTemplateId
          ? { ...item, AccountProjectTaskId: selected.value }
          : item
      )
    ) : setTimesheetTemplateResponse((prevState: any) => {
      const updatedState = [...prevState];
      if (index >= 0 && index < updatedState.length) {
        updatedState[index] = {
          ...updatedState[index],
          AccountProjectTaskId: selected.value
        };
      }
      return updatedState;
    });
  }

  const updateTimesheetTemplate = async () => {
    let rowCount: number[] = [];
    let errorMessage: string = "";
    timesheetTemplateResponse.map((item: any, index: number) => {
      if (item.AccountProjectId === 0 || item.AccountProjectTaskId === 0) {
        rowCount.push(index + 1);
        errorMessage = "Please select the project name and task name from the list for rows " + rowCount.toString();
      }
    });
    if (errorMessage != "") {
      let messageArray: string[] = [];
      errorMessage != "" && messageArray.push(errorMessage);
      setErrorValues({
        ...setError,
        isError: true,
        errorMessage: messageArray
      });
    } else {
      setIsDisabled(true);
      setErrorValues({
        ...setError,
        isError: false,
        errorMessage: []
      });
      let finalArray: any[] = [];
      timesheetTemplateResponse.map((item: any) => {
        finalArray.push({
          "AccountEmployeeTimeEntryTemplateId": item.AccountEmployeeTimeEntryTemplateId,
          "AccountEmployeeId": item.AccountEmployeeId,
          "AccountProjectId": item.AccountProjectId,
          "AccountProjectTaskId": item.AccountProjectTaskId,
          "AccountId": item.AccountId,
          // "IsReact": true
          "AccountClientId": item.AccountClientId
        });
      });
      try {
        setIsLoading(true);
        const response: any = await fetchAPI(`api/v2/TimesheetTemplate/AddAndUpdateTimesheetTemplate`, "POST", finalArray, true);
        const json = await response.json();
        if (json.id != "-1") {
          getTimesheetTemplateAsync();
          ShowToast('Success', json.message, "success", "toast-top-right");
        } else {
          ShowToast('Error', json.message, "error", "toast-top-right");
        }
      } catch (error) {
      } finally {
        finalArray = [];
        setIsLoading(false);
      }
    }
  }

  const addRow = () => {
    let tempTimesheetTemplate: any[] = [];
    tempTimesheetTemplate.push({
      "AccountClientId": 0,
      "AccountProjectId": 0,
      "AccountProjectTaskId": 0,
      "AccountEmployeeId": accountEmployeeId,
      "AccountEmployeeTimeEntryTemplateId": "",
      "AccountId": sessionAccountId,
      "ProjectTaskArray": [{ "value": 0, "label": "None" }],
      "IsTaskDisabled": true,
      "ProjectArray": [{ "value": 0, "label": "None" }],
      "IsProjectDisabled": true,
      "IsProjectTaskRender": false
    });
    setTimesheetTemplateResponse((prevState: any) => [
      ...prevState,
      tempTimesheetTemplate[0]
    ]);
  }

  const deleteRow = (rowIndex: number, accountEmployeeTimeEntryTemplateId: string) => {
    let tempArray: any[] = [];
    timesheetTemplateResponse.map((item: any, index: number) => {
      if (rowIndex != index) {
        tempArray.push(item);
      }
    });
    if (accountEmployeeTimeEntryTemplateId === "") {
      setTimesheetTemplateResponse(tempArray);
    } else {
      ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
        .then(async (result) => {
          if (result) {
            try {
              setIsLoading(true);
              const response: any = await fetchAPI(`api/v2/TimesheetTemplate/${accountEmployeeTimeEntryTemplateId}`, "Delete", true);
              const json = await response.json();
              if (json.id != "-1") {
                setTimesheetTemplateResponse(tempArray);
                ShowToast('Success', json.message, "success", "toast-top-right");
              } else {
                ShowToast('Error', json.message, "error", "toast-top-right");
              }
            } catch (error) {
            } finally {
              setIsLoading(false);
            }
          }
        })
        .catch((error) => {
        });
    }
  }

  return (
    <>
      {isLoading && <Loader />}
      <div className="card card-custom admin-card">
        <div className="card-header sticky-top bg-white">
          <h3 className="card-title fw-bold headerTitle">
            {/* {t('Timesheet Template')} */}
            {getValueFromResource('Timesheet Template', dispatch, t)}
          </h3>
          <div className="card-toolbar align-items-center">
            <div className='d-flex align-items-center'>
              <div className='d-flex align-items-center'>
                <a
                  onClick={() => { addRow() }}
                  className="btn btn-primary btn-sm">
                  {getValueFromResource('Add Row', dispatch, t)}
                </a>
                {timesheetTemplateResponse.length > 0 && <>
                  <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                  {/* <a
                  onClick={() => { updateTimesheetTemplate() }}
                  className={`btn btn-primary btn-sm ${isDisabled ? 'disabled' : ''}`}
                >
                  {getValueFromResource('Update', dispatch, t)}
                </a> */}
                  <button
                    onClick={() => { updateTimesheetTemplate() }}
                    disabled={isDisabled}
                    className="btn btn-primary btn-sm"
                  >
                    {getValueFromResource('Update', dispatch, t)}
                  </button>
                </>}
              </div>
            </div>
          </div>
        </div>
        {setError.isError && <div id="validationerror" className="alert alert-danger">
          <strong>Error!</strong>
          <ul>
            {setError.errorMessage.map((item: any, index: number) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>}
        <div className="card-body py-3">
          <div className="table-responsive">
            <table className="table table-row-bordered align-middle gs-1 gy-2 gx-1">
              <thead>
                <tr className="thHeading align-middle">
                  {showClientInTimesheet && <th style={{ width: '35%' }}>
                    {getValueFromResource('Client Name', dispatch, t)}
                  </th>}
                  <th style={{ width: '35%' }}>
                    {getValueFromResource('Project Name', dispatch, t)}
                  </th>
                  <th style={{ width: '35%' }}>
                    {getValueFromResource('Task Name', dispatch, t)}
                  </th>
                  <th style={{ width: '5%' }}></th>
                </tr>
              </thead>
              <tbody>
                {timesheetTemplateResponse.length > 0 && timesheetTemplateResponse.map((item: any, index: number) => (
                  <tr>
                    {showClientInTimesheet && <td>
                      <Select
                        value={clientResponse.filter((x: any) => x.value === (item.AccountClientId === null ? 0 : item.AccountClientId))}
                        className="basic-single fs-7 fw-normal"
                        classNamePrefix="select"
                        options={clientResponse}
                        styles={localColourStyles}
                        menuPortalTarget={document.body}
                        menuPosition='fixed'
                        name="clientArray"
                        onChange={(e, name) => onHandleClientChange(e, item.AccountEmployeeTimeEntryTemplateId, index)}
                      />
                    </td>}
                    <td>
                      <Select
                        value={showClientInTimesheet ? item.ProjectArray.filter((x: any) => x.value === item.AccountProjectId) : projectResponse.filter((x: any) => x.value === item.AccountProjectId)}
                        className="basic-single fs-7 fw-normal"
                        classNamePrefix="select"
                        options={showClientInTimesheet ? item.ProjectArray : projectResponse}
                        styles={localColourStyles}
                        isDisabled={showClientInTimesheet ? item.IsProjectDisabled : false}
                        menuPortalTarget={document.body}
                        menuPosition='fixed'
                        name="projectArray"
                        onChange={(e) => onHandleProjectChange(e, item.AccountEmployeeTimeEntryTemplateId, index)}
                        onMenuOpen={() => (item.AccountEmployeeTimeEntryTemplateId != "" && showClientInTimesheet) && getAccountProjectsByAccountClientId(item.AccountClientId, item.AccountEmployeeTimeEntryTemplateId)}
                      />
                    </td>
                    <td>
                      <Select
                        value={item.ProjectTaskArray.filter((x: any) => x.value === item.AccountProjectTaskId)}
                        className="basic-single fs-7 fw-normal"
                        classNamePrefix="select"
                        options={item.ProjectTaskArray}
                        styles={localColourStyles}
                        isDisabled={item.IsTaskDisabled}
                        menuPortalTarget={document.body}
                        menuPosition='fixed'
                        name="projectTaskArray"
                        onChange={(e) => onHandleProjectTaskChange(e, item.AccountEmployeeTimeEntryTemplateId, index)}
                        onMenuOpen={() => item.AccountEmployeeTimeEntryTemplateId != "" && getAccountProjectTaskByAccountProjectId(item.AccountProjectId, item.AccountEmployeeTimeEntryTemplateId)}
                      />
                    </td>
                    <td className='text-center'>
                      <span className="menu-icon custom-menu mb-2 cursor"
                        onClick={() => deleteRow(index, item.AccountEmployeeTimeEntryTemplateId)}
                        data-tooltip-id="tooltip-Description"
                        data-tooltip-content={t("Delete")}
                        data-tooltip-place="top">
                        <i className="bi bi-trash fs-6 iconColor allign">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {timesheetTemplateResponse.length === 0 &&
              <div className=''>
                <p className='noDataFound'>
                  {getValueFromResource('No Record Found', dispatch, t)}
                </p>
              </div>
            }
          </div>
        </div>
      </div>
    </>
  )
}

const localColourStyles: StylesConfig = {
  control: (styles) => ({
    ...styles,
    backgroundColor: 'white',
    height: '100%',
    padding: '-1px',
    borderColor: '#EBECF0'
    // width: 400
  })
}

export default TimesheetTemplate